<template>
  <div class="tour-travel-expert">
    <div class="tour-travel-expert__wrapper">
      <portal-target :name="avatarPortalId" slim />
      <div class="tour-travel-expert__container">
        <div class="tour-travel-expert__top">
          <div
            @click.stop.prevent="openExpertLink"
            class="
              tour-travel-expert__title
              serp-detail__section-title
              u-flex-grow
            "
          >
            {{ $t("common.organizer") }}: {{ expertData.title }}
            {{ expertData.name }}
          </div>
          <portal :to="avatarPortalId" :disabled="sizeSm || sizeLg" slim>
            <div
              href="#"
              @click.stop.prevent="openExpertLink"
              :title="expertData.name"
              target="_blank"
              class="tour-travel-expert__avatar u-flex-shrink-0"
            >
              <avatar :name="expertData.name" :photo="expertData.avatar" />
            </div>
          </portal>
        </div>
        <div class="tour-travel-expert__stats">
          <button-icon tag="a" :href="linkReviews" target="_blank">
            <template #icon>
              <icon icon="star" />
            </template>
            <span class="font-regular">
              <template v-if="expertData.count_reviews">
                {{ expertData.rating_expert }}
              </template>
              <span class="u-text-secondary"
                >({{ $tc("reviews.reviews", +expertData.count_reviews) }})</span
              >
            </span>
          </button-icon>
          <button-icon tag="span">
            <template #icon>
              <icon icon="flag" />
            </template>
            <span class="font-regular">
              {{ expertData.travel_held }}
            </span>
          </button-icon>
          <button-icon v-if="expertData.trust_check" tag="span">
            <template #icon>
              <icon icon="icon-shield-checked" />
            </template>
            <span class="font-regular">
              {{ $t("common.verified") }}&nbsp;&mdash;
              {{ expertData.date_register }}
            </span>
          </button-icon>
        </div>
      </div>
    </div>
    <div class="tour-travel-expert__ask">
      <yt-button
        :color="getChatButtonClass"
        class="tour-travel-expert__ask-button"
        squared
        @click="clickAskButton"
        >{{ $t("common.contact") }}</yt-button
      >
      <popup-contact-travel-expert
        v-model="popups.ask"
        :expert-data="expertData"
        :tour-name="tourName"
        :trip-id="tripId"
      />
      <div class="tour-travel-expert-answer-time" v-bind:style="{ display: display }">
        <Icon icon="ClockAnswer" /> {{ $t("common.answerTime") }} {{ expertData.answer_time }}
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/ui-kit/avatar/index.vue";
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import PopupContactTravelExpert from "@/components/organisms/contact-travel-expert/popup.vue";
import { sizeSm, sizeLg } from "@/assets/js/utils/mq";
import {abTestController} from "@/plugins/abtest";
import {ytEvents} from "@/plugins/analytics";

export default {
  components: {
    Avatar,
    ButtonIcon,
    Icon,
    YtButton,
    PopupContactTravelExpert,
  },
  props: {
    expertData: {
      type: Object,
      required: true,
    },
    tourName: {
      type: String,
      default: "",
    },
    tripId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      display: this.isAbTest16590() ? 'flex' : 'none',
      popups: {
        ask: false,
      },
    };
  },
  computed: {
    avatarPortalId() {
      return `tour-travel-expert-avatar-portal-${this.expertData.expert_id}`;
    },
    link() {
      return this.expertData.link;
    },
    linkReviews() {
      return `${this.expertData.link}#reviews`;
    },
    sizeSm,
    sizeLg,
    getChatButtonClass() {
      return this.isAbTest15919() ? 'violet' : 'gray';
    },
  },
  methods: {
    openExpertLink(event) {
      event.preventDefault(); // Предотвращаем стандартное поведение клика
      event.stopPropagation(); // Останавливаем всплытие события
      fakeWindow.open(this.link,'_blank').focus();
    },
    isAbTest15919() {
      return abTestController.getSegment(15919) === 'B'
    },
    isAbTest16590() {
      return abTestController.getSegment(16590) === 'B'
    },
    clickAskButton() {
      this.popups.ask = true;
      ytEvents.track("Tour detail" , "Click Message to expert button",);
      if (typeof window.youtravel.DataCollector !== "undefined") {
        window.youtravel.DataCollector.trackEvent("Tour detail", "Click Message to expert button", {
          'tour_id': this.tripId || "",
          'list': "",
          'filter': {},
          'additional': {},
          'meta': {}
        })
      }

    }
  },
};
</script>

<style lang="scss" scoped>
.tour-travel-expert {
  background: var.$white;
  border: 1px solid var.$gray-light;
  border-radius: 16px;
  box-shadow: 2px 2px 15px rgba(var.$secondary, 0.15);
  padding: 24px;

  &__wrapper {
    @include mixin.size-md-only {
      display: flex;
      align-items: center;
    }

    @include mixin.size-xl-min {
      display: flex;
      align-items: center;
    }
  }

  &__top {
    display: flex;
    align-items: flex-start;
    margin-bottom: 16px;

    @include mixin.size-md-only {
      display: block;
      margin-bottom: 14px;
    }

    @include mixin.size-xl-min {
      display: block;
      margin-bottom: 14px;
    }
  }

  &__title {
    display: block;
    cursor: pointer;
    color: var.$black;
    margin: 0;
  }

  &__avatar {
    display: block;
    cursor: pointer;
    width: 64px;
    margin-left: 20px;

    @include mixin.size-md-only {
      width: 96px;
      margin-right: 20px;
      margin-left: 0;
    }

    @include mixin.size-xl-min {
      width: 96px;
      margin-right: 20px;
      margin-left: 0;
    }
  }

  &__stats {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    > * {
      margin-top: 6px;

      &:not(:last-child) {
        margin-right: 16px;
      }

      &:first-child {
        cursor: pointer;
      }
    }
  }

  &__ask {
    margin-top: 24px;
    display: flex;
    align-items: center;
    flex-direction: column;

    @include mixin.size-sm-min {
      flex-direction: row;
    }

    &-button {
      width: 100%;

      @include mixin.size-sm-min {
        width: auto;

      }
    }
  }

  @media (max-height: 460px) {
    .button.tour-travel-expert__ask-button {
      width: 100%;
    }
  }

  &-answer-time {
    color: #9999a9;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-top: 10px;

    @include mixin.size-sm-min {
      margin-top: 0;
    }

    svg {
      margin-left: 10px;
      margin-right: 5px;
    }

    @media (max-height: 460px) {
      flex-direction: column;
      margin-left: 0;
      margin-right: 0;
      margin-top: 15px;
    }
  }
}
</style>
